export default "__VITE_ASSET__4121a8ed__"